var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fenye"},[_c('div',{staticClass:"fybtn",on:{"click":_vm.gotoShouye}},[_vm._v("首页")]),_c('div',{staticClass:"fybtn",on:{"click":_vm.gotoShangyiye}},[_vm._v("上一页")]),_c('div',{staticClass:"fybtn",on:{"click":_vm.gotoXiayiye}},[_vm._v("下一页")]),_c('div',{staticClass:"fybtn",on:{"click":_vm.gotoWeiye}},[_vm._v("尾页")])])
}
var staticRenderFns = []

export { render, staticRenderFns }